/* eslint-disable @typescript-eslint/no-explicit-any */
import { createSlice } from '@reduxjs/toolkit';

import {
 commonReducers,
 CommonState,
 initialCommonState,
} from '../_common/commonReducers';

export interface Card {
 Id: number;
 Name: string;
 Description: string;
 CreatedAt: string;
 UpdatedAt: string;
}

interface CardsState extends CommonState {}

const initialState: CardsState = {
 ...initialCommonState,
};

const cardsSlice = createSlice({
 name: 'cards',
 initialState,
 reducers: {
  ...commonReducers,
 },
});

export const {
 getTableStart,
 getTableSuccess,
 getTableFailure,
 getTableFinish,

 getItemStart,
 getItemSuccess,
 getItemFailure,

 createItemStart,
 createItemSuccess,
 createItemFailure,
 createItemFinish,

 updateItemStart,
 updateItemSuccess,
 updateItemFailure,
 updateItemFinish,

 deleteItemsStart,
 deleteItemsSuccess,
 deleteItemsFailure,
 deleteItemsFinish,

 deleteItemStart,
 deleteItemSuccess,
 deleteItemFailure,
 deleteItemFinish,

 getTableStructureStart,
 getTableStructureSuccess,
 getTableStructureFailure,

 getItemDocumentsStart,
 getItemDocumentsSuccess,
 getItemDocumentsFailure,

 uploadItemDocumentsStart,
 uploadItemDocumentsSuccess,
 uploadItemDocumentsFailure,
 uploadItemDocumentsFinish,

 deleteItemDocumentStart,
 deleteItemDocumentSuccess,
 deleteItemDocumentFailure,
 deleteItemDocumentFinish,

 getTableExcelStart,
 getTableExcelSuccess,
 getTableExcelFailure,
 getTableExcelFinish,
} = cardsSlice.actions;
export default cardsSlice;
